import { render, staticRenderFns } from "./chart-create-fields.vue?vue&type=template&id=1cdb42c8"
import script from "./chart-create-fields.vue?vue&type=script&lang=ts"
export * from "./chart-create-fields.vue?vue&type=script&lang=ts"
import style0 from "./chart-create-fields.vue?vue&type=style&index=0&id=1cdb42c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports